module.exports = __webpack_public_path__ + "img/icontype9.d5af8eac.png";